import { useCallback, useState } from 'react';

export const useRestrictionsDrawerState = () => {
  const [activeManifestId, setActiveManifestId] = useState<
    string | undefined
  >();
  const [highlightedLines, setHighlightedLines] = useState<number[]>([]);
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>();

  const handleItemClick = useCallback(
    (itemId: string, manifestId: string, lines: number[]) => {
      setSelectedItemId(itemId);
      setActiveManifestId(manifestId);
      setHighlightedLines(lines);
    },
    []
  );

  return {
    activeManifestId,
    highlightedLines,
    selectedItemId,
    handleItemClick,
  };
};
